// Victory overlay component

import { css, html } from 'lit';
import { BaseComponent } from '../../lib/base-component.js';

/**
 * Victory overlay component
 * Displays when the adventure is completed
 */
class VictoryOverlay extends BaseComponent {
  static properties = {
    show: { type: Boolean },
  };

  static styles = css`
    :host {
      display: block;
    }

    .victory-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.85);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;
      animation: fadeIn 0.5s ease-out;
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    .victory-content {
      text-align: center;
      color: #ffd700;
      animation: scaleIn 0.5s ease-out;
    }

    @keyframes scaleIn {
      from {
        transform: scale(0.8);
        opacity: 0;
      }
      to {
        transform: scale(1);
        opacity: 1;
      }
    }

    .victory-icon {
      margin-bottom: 1rem;
      animation: bounce 1s ease-in-out infinite;
    }

    @keyframes bounce {
      0%,
      100% {
        transform: translateY(0);
      }
      50% {
        transform: translateY(-10px);
      }
    }

    .victory-title {
      font-size: 3rem;
      font-weight: bold;
      margin: 0 0 0.5rem 0;
      text-shadow: 0 0 20px rgba(255, 215, 0, 0.5);
    }

    .victory-message {
      font-size: 1.25rem;
      color: #e0e0e0;
      margin: 0 0 2rem 0;
    }

    .end-game-btn {
      background: linear-gradient(135deg, #28a745, #218838);
      color: #fff;
      border: none;
      padding: 1rem 2rem;
      font-size: 1.25rem;
      font-weight: bold;
      border-radius: 8px;
      cursor: pointer;
      transition:
        transform 0.2s,
        box-shadow 0.2s;
    }

    .end-game-btn:hover {
      transform: scale(1.05);
      box-shadow: 0 0 20px rgba(40, 167, 69, 0.5);
    }

    .end-game-btn:active {
      transform: scale(0.98);
    }

    .icon {
      width: 64px;
      height: 64px;
    }
  `;

  constructor() {
    super();
    this.show = false;
  }

  _handleEndGame() {
    this.dispatchEvent(new CustomEvent('end-game', { bubbles: true }));
  }

  _renderTrophyIcon() {
    return html`
      <svg
        class="icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
        <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
        <path d="M4 22h16" />
        <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22" />
        <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22" />
        <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z" />
      </svg>
    `;
  }

  render() {
    if (!this.show) {
      return html``;
    }

    return html`
      <div class="victory-overlay">
        <div class="victory-content">
          <div class="victory-icon">${this._renderTrophyIcon()}</div>
          <h1 class="victory-title">Victory!</h1>
          <p class="victory-message">You have completed the adventure.</p>
          <button class="end-game-btn" @click="${this._handleEndGame}">End Game</button>
        </div>
      </div>
    `;
  }
}

customElements.define('victory-overlay', VictoryOverlay);
